define('views/pages/account/AccountSponsorshipView',[
        'underscore',
        'jquery',
        'views/pages/account/AccountView',
        'app',
        'WidgetCollectionView',
        'Components/SponsorshipWidget/js/views/SponsorshipWidgetInstanceView'
    ],
    function (_, $, AccountView, app, WidgetCollectionView, SponsorshipWidgetInstanceView) {

        var wrapHtml = function (title) {
            return '<section class="account-sponsorship-widget">' +
                '<div class="account-sct-title">' +
                '<h2 class="main-title">' + title + '</h2>' +
                '</div>' +
                '</section>';
        };

        return AccountView.extend(SponsorshipWidgetInstanceView).extend({
            initialize: function () {
                var view = this;
                AccountView.prototype.initialize.apply(view, arguments);
                view.render();

            },
            render: function () {
                var collection = new WidgetCollectionView('parrainage');
                var $el = wrapHtml(t('Mon offre de parrainage', 'Sponsorship'));
                this.$el.html($($el).append(collection.el));
                this.attachView(collection);
            }
        });
    });
